import React from 'react';
import { Field, reduxForm, FieldArray } from 'redux-form';
import CardPunteado from "../../../../../Utils/Cards/CardPunteado";
import CreditLineTable from "./CreditLineTable";
import BankCreditTable from "./BankCreditTable"
import SalesAdvanceTable from './SalesAdvanceTable';
import { renderFieldDisabled, renderTypeOfDebtDisabled, renderPercentageDisabled } from "../../../../../Utils/renderField/renderField";
import Swal from 'sweetalert2';
const alerta = require('assets/img/icons/alerta_roja.png');
import validate from './validate';
import editar_img from 'assets/img/icons/editar.svg';
import { connect } from 'react-redux';

const renderCategory = ({ fields, openModal, readAnnualEdit, initializeEmptyAnnualForm, data, eliminarAnnual, isEdition, isCreate }) => {

    const delete_category = (index, id) => {
        let message = '¿Estás seguro de confirmar todos los cambios?';
        const SwalMod = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-primary btn-modal',
                cancelButton: 'btn btn-outline-dark mr-5 btn-modal',
                content: '',
                title: 'darck',
                popup: 'custom-modal-size',
            },
            buttonsStyling: false,
            showCloseButton: true,
            focusConfirm: false,
            focusCancel: false,
            padding: "1em",
        });

        SwalMod.fire({
            title: 'ADVERTENCIA',
            html: 'Si eliminas la categoría perderás toda la información, <br/>' + message,
            imageUrl: alerta,
            imageAlt: 'Alerta',
            showCancelButton: true,
            confirmButtonText: 'CONTINUAR',
            cancelButtonText: 'CANCELAR',
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                fields.remove(index);
                eliminarAnnual(id)

            }
        });
    }

    const abrirModalYConsultar = (id) => {
        readAnnualEdit(id);
        openModal();
        isEdition()
    };
    const abrirModaVacio = () => {
        openModal();
        initializeEmptyAnnualForm(data);
        isCreate()
    };
    const TYPE_OF_DEBIT = {
        LINE_OF_CREDIT: 10,
        PROMISSORY_NOTE: 20,
        BANK_CREDIT: 30,
        SALES_ADVANCE: 40,

    };

    const TYPE_OF_DEBT_LABELS = {
        10: 'LÍNEA DE CRÉDITO',
        20: 'PAGARÉ',
        30: 'CRÉDITO BANCARIO',
        40: 'ANTICIPO DE VENTAS'
    };
    const tableComponents = {
        [TYPE_OF_DEBIT.LINE_OF_CREDIT]: CreditLineTable,
        [TYPE_OF_DEBIT.SALES_ADVANCE]: SalesAdvanceTable,
        [TYPE_OF_DEBIT.BANK_CREDIT]: BankCreditTable,
    };



    return (
        <div>
            {fields.map((table, index) => {
                const currentTableData = fields.get(index);
                const SelectedTableComponent = tableComponents[currentTableData.type_of_debt] || BankCreditTable;
                return (
                    <div key={index} className='col-sm-12 p-0'>
                        <hr />
                        <div className="mt-2">
                            <div className="col-12 p-0 mt-2">
                                <div className="d-flex flex-wrap justify-content-between">
                                    <div className="form-group mr-3 flex-grow-1">
                                        <label htmlFor="name" className="m-0">Tipo de crédito</label>
                                        <Field
                                            name={`${table}.type_of_debt`}
                                            component={renderTypeOfDebtDisabled}
                                            width="100%"
                                            labels={TYPE_OF_DEBT_LABELS}
                                            applyStyles={true}
                                            isTextarea={false}
                                        />
                                    </div>
                                    <div className="form-group mr-3 flex-grow-1">
                                        <label htmlFor="name" className="m-0">Nombre del presupuesto</label>
                                        <Field
                                            name={`${table}.name`}
                                            component={renderFieldDisabled}
                                            width="100%"
                                            applyStyles={false}
                                            isTextarea={false}
                                        />
                                    </div>
                                    {(currentTableData.type_of_debt === TYPE_OF_DEBIT.SALES_ADVANCE) ?
                                        <div className="form-group mr-3 flex-grow-1">
                                            <label htmlFor="name" className="m-0">Taza de descuento</label>
                                            <Field
                                                name={`${table}.debt_management_parameters.interest_rate`}
                                                component={renderPercentageDisabled}
                                                width="100%"
                                                style={{ fontWeight: "bold" }}
                                                applyStyles={false}
                                                isTextarea={false}
                                            />
                                        </div>
                                        :
                                        <div className="form-group mr-3 flex-grow-1">
                                            <label htmlFor="name" className="m-0">Porcentaje de interés</label>
                                            <Field
                                                name={`${table}.debt_management_parameters.interest_rate`}
                                                component={renderPercentageDisabled}
                                                width="100%"
                                                style={{ fontWeight: "bold" }}
                                                applyStyles={false}
                                                isTextarea={false}
                                            />
                                        </div>
                                    }
                                    {(currentTableData.type_of_debt === TYPE_OF_DEBIT.LINE_OF_CREDIT

                                    ) ? (
                                        <div className="form-group flex-grow-1">
                                            <label htmlFor="name" className="m-0">Días de plazo</label>
                                            <Field
                                                name={`${table}.debt_management_parameters.days_of_term`}
                                                component={renderFieldDisabled}
                                                width="100%"
                                                applyStyles={false}
                                                isTextarea={false}
                                            />
                                        </div>
                                    ) : (currentTableData.type_of_debt === TYPE_OF_DEBIT.SALES_ADVANCE) ?
                                        <div className="form-group flex-grow-1">
                                            <label htmlFor="name" className="m-0">Días de crédito</label>
                                            <Field
                                                name={`${table}.debt_management_parameters.days_of_term`}
                                                component={renderFieldDisabled}
                                                width="100%"
                                                applyStyles={false}
                                                isTextarea={false}
                                            />
                                        </div>
                                        : (
                                            <div className="form-group flex-grow-1">
                                                <label htmlFor="name" className="m-0">Plazo</label>
                                                <Field
                                                    name={`${table}.debt_management_parameters.time_of_term`}
                                                    component={renderFieldDisabled}
                                                    width="100%"
                                                    applyStyles={false}
                                                    isTextarea={false}
                                                />
                                            </div>
                                        )}
                                    <div className="d-flex justify-content-center">
                                        <button
                                            type='button'
                                            onClick={() => abrirModalYConsultar(currentTableData.id)}
                                            style={{ border: 'none', background: 'none' }}
                                        >
                                            <img src={editar_img} alt="Editar" className="action_img" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div type="button" className="btn btn-light btn-lg btn-block d-flex justify-content-end mb-2 eliminar-tab-generica" onClick={() => delete_category(index, currentTableData.id)}>
                                ELIMINAR
                            </div>
                        </div>
                        <SelectedTableComponent 
                        fieldName={`${table}.rows`} 
                        data={data}
                        />
                        <br/>
                        <br/>
                    </div>
                );
            })}
            <div className='mb-4'>
                <CardPunteado>
                    <div className='p-4 mb-4'>
                        <button type="button" className="btn btn-categories " onClick={(e) => { e.preventDefault(); abrirModaVacio(); }}>
                            + AGREGAR
                        </button>
                    </div>
                </CardPunteado>
            </div>
        </div>
    );
}

let AnnualDebtManagementForm = props => {
    const { handleSubmit, readAnnualEdit, item, openModal, closeModal, eliminarAnnual, initializeEmptyAnnualForm, isEdition, isCreate, annual_data } = props;

    return (
        <form onSubmit={handleSubmit}>
            <div className='col-sm-12 p-0'>
                    <FieldArray
                        name="details"
                        dollar_exchange={item}
                        openModal={openModal}
                        closeModal={closeModal}
                        readAnnualEdit={readAnnualEdit}
                        component={renderCategory}
                        change={props.change}
                        initializeEmptyAnnualForm={initializeEmptyAnnualForm}
                        eliminarAnnual={eliminarAnnual}
                        isEdition={isEdition}
                        isCreate={isCreate}
                        data={annual_data}
                    />
                <div className='buttons-box mt-5'>
                    <button type="submit"
                        className="btn btn-primary m-4 btn-modal"
                    >
                        CONFIRMAR
                    </button>
                </div>
            </div>
        </form>
    );
};

const mapStateToProps = (state) => ({
    initialValues: (state.form && state.form.AnnualDebtManagementForm && state.form.AnnualDebtManagementForm.values) || {},
});

AnnualDebtManagementForm = connect(mapStateToProps)(
    reduxForm({
        form: 'AnnualDebtManagementForm',
        validate,
        enableReinitialize: true,
    })(AnnualDebtManagementForm)
);

export default AnnualDebtManagementForm;
